module.exports = __webpack_public_path__ + "img/profile_adobespark.3505dcd2.png";